module.exports = __webpack_public_path__ + "img/icon_attribute_pure.8d5b4e4f.png";